export const BundleCouponClassCodes = [
  'RCALIREONEFY24BUNDLEC1',
  'RCALIREONEFY24BUNDLEC2',
  'RCALIREONEFY24BUNDLEC3',
  'RCALIREONEFY24BUNDLEC4',
  // Prod Test Coupon
  'RDIINENGRFY25US5', // (spend $1 get $5)
  'RDIINENGIFY25US100', // spend $50 get $100 coupons
  // Prod Coupon
  'APAINFY25FY25US100',
  'APAINFY26FY26US100',
];
